import { makeStyles } from "tss-react/mui";

export const useCreateWalrDataProjectDialogStyles = makeStyles()((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    gap: "24px",
    overflowY: "auto",
    fontFamily: "MD Primer",
  },
  title: {
    fontSize: "24px",
    fontWeight: "600",
  },
  input: {
    "& input": {
      paddingTop: 0,
      backgroundColor: "var(--bg-white)",
      borderColor: "grey",
      paddingLeft: 0,
    },
  },
  autoComplete: {
    width: "100%",
    "& .MuiInputBase-root": {
      padding: "0px 9px !important",
    },
    "& .MuiAutocomplete-input": {
      paddingRight: `${theme.spacing(3)} !important`,
    },
  },
  optionTooltip:{
    maxWidth: 'none',
 },
  formItem: {
    display: "flex",
    width: "100%",
    overflowY: "auto",
    flexDirection: "column",
  },
  label: {
    fontSize: "16px",
    fontWeight: "400",
  },
  actions: {
    display: "flex",
    gap: 24,
    fontSize:"16px",
    fontWeight:"400",
    justifyContent: "center",
    width: "100%",
    marginBottom: 24,
  },
  btnBack: {
    fontSize: "16px",
    fontWeight: "400",
    marginLeft: -12,
  },
  backIcon: {
    marginRight: 4,
    width: "14px",
    height: "14px",
    fontSize: "14px"
  },
  spinner: {
    marginLeft: 10,
    width: "20px !important",
    height: "20px !important",
    color: "var(--color-secondary)",
  },
  message: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "justify",
  },
  messageTitle: {
    top: 65,
    fontSize: "1.5rem",
    fontWeight: "bold",
    marginBottom: 25,
    alignSelf: "start",
  },
  messageBody: {
    fontSize: "1rem",
    lineHeight: "2rem",
    marginBottom: 24,
    "& div": {
      marginBottom: 24,
    },
    "& div:last-child": {
      marginBottom: 0,
    },
  },
}));
